import { requireAuth } from '@/features/auth/guards/require-auth'
import { ProductionReportEditorPage } from '@/features/production-reports/pages/production-report-editor-page'
import { productionReportDetailQuery } from '@/features/production-reports/queries/production-report-queries'
import { projectsListQuery } from '@/features/projects/queries/projects-query'
import { usersListQuery } from '@/features/references/users/users-query'
import { workOrderQuery } from '@/features/work-orders/queries/work-order-detail-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'
import * as z from 'zod'

const paramsSchema = z.object({
  productionReportId: z.coerce.number().int().positive(),
})

export const Route = createFileRoute('/_app/production-reports/$productionReportId')({
  beforeLoad: requireAuth,
  parseParams: paramsSchema.parse,
  stringifyParams: ({ productionReportId }) => ({ productionReportId: String(productionReportId) }),
  loader: async ({ params, context }) => {
    const qc = context.queryClient
    const record = await qc.ensureQueryData(productionReportDetailQuery(params.productionReportId))
    const promises: Promise<unknown>[] = [
      qc.ensureQueryData(projectsListQuery()),
      qc.ensureQueryData(usersListQuery()),
    ]
    if (record.work_order_id != null) {
      promises.push(qc.ensureQueryData(workOrderQuery(record.work_order_id)))
    }
    await Promise.all(promises)
    return { number: record.number }
  },
  // Crumb: «<список> › <номер документа>» — the number from the loader, not the id.
  staticData: {
    crumbParent: { label: messages.crumbs.productionReports, to: '/production-reports/' },
    crumb: (m: { loaderData?: { number: string } }) => m.loaderData?.number ?? '…',
  },
  component: () => {
    const { productionReportId } = Route.useParams()
    return <ProductionReportEditorPage productionReportId={productionReportId} />
  },
})
